import i18n from "@/i18n/index.ts";
export default class DataGlossary {
}
DataGlossary.Breadcrumbs = [
    {
        to: "/",
        text: i18n.t("breadcrumbs.home"),
    },
    {
        to: "/",
        text: i18n.t("breadcrumbs.cms"),
    },
    {
        to: "/cms/glossary/list",
        text: i18n.t("breadcrumbs.glossary"),
        disabled: true,
    },
];
DataGlossary.TableHeaders = [
    {
        text: i18n.t("breadcrumbs.letter"),
        value: "letter",
        width: "80px",
    },
    {
        text: i18n.t("breadcrumbs.term"),
        value: "term",
    },
    {
        text: i18n.t("breadcrumbs.definition"),
        value: "definition",
    },
    {
        text: i18n.t("breadcrumbs.is_advanced"),
        value: "is_advanced",
        width: "120px",
    },
    {
        text: i18n.t("breadcrumbs.is_visible"),
        value: "is_visible",
        width: "120px",
    },
    {
        text: i18n.t("breadcrumbs.related_links"),
        value: "related_links",
        sortable: false,
        width: "110px",
    },
    {
        text: i18n.t("breadcrumbs.action"),
        value: "action",
        sortable: false,
        width: "140px",
    },
];
